import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Marketing from "@/pages/Marketing";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Contact from "@/pages/Contact";
import PublicPage from "@/pages/PublicPage";
import DemoPage from "@/pages/DemoPage";
import Admin from "@/pages/app/Admin";
import Login from "@/pages/app/Login";
import Onboarding from "@/pages/app/Onboarding";
import Subscribe from "@/pages/app/Subscribe";
import Dashboard from "@/pages/app/Dashboard";
import AuthCallback from "@/pages/app/AuthCallback";
import ProtectedRoute from "@/components/app/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  const sessionIdInHash = location.hash?.includes("session_id=");
  const sessionIdInQuery = new URLSearchParams(location.search).has("session_id");
  if (sessionIdInHash || sessionIdInQuery) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Marketing />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/demo" element={<DemoPage />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/login" element={<Login mode="signin" />} />
      <Route path="/signup" element={<Login mode="signup" />} />
      <Route
        path="/onboarding"
        element={<ProtectedRoute>{() => <Onboarding />}</ProtectedRoute>}
      />
      <Route
        path="/app"
        element={<ProtectedRoute>{(user) => <Dashboard user={user} />}</ProtectedRoute>}
      />
      <Route
        path="/subscribe"
        element={<ProtectedRoute>{() => <Subscribe />}</ProtectedRoute>}
      />
      <Route path="/:slug" element={<PublicPage />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
